<template>
<div class="chapter">
<div class="inner_page">
<p class="para"> </p>
<p class="copy"><a id="page_viii"></a>First published in hardback in Great Britain in 2023 by Polygon, an imprint of Birlinn Ltd.</p>
<p class="copy">Birlinn Ltd<br/>West Newington House<br/>10 Newington Road<br/>Edinburgh<br/>EH9 1QS</p>
<p class="copy"><a href="http://www.polygonbooks.co.uk" target="_blank">www.polygonbooks.co.uk</a></p>
<p class="copy">1</p>
<p class="copy">Copyright © Alan Warner, 2023</p>
<p class="copy">The right of Alan Warner to be identified as the author of this work has been asserted in accordance with the Copyright, Designs and Patents Act 1988.</p>
<p class="copy">All rights reserved.</p>
<p class="copy">ISBN 978 1 84697 569 1<br/>eBook ISBN 978 1 78885 530 3</p>
<p class="copy">Typeset by 3btype, Edinburgh</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?aff85cb8